import React, {useState, useEffect, useRef} from 'react';
import {Modal, Toast} from 'antd-mobile-v2';
import Slider from 'react-slick';
import {observer} from 'mobx-react-lite';
import queryString from 'query-string';
import {useStore} from '@/store/hooks';
import BackHeader from '@comp/BackHeader/index';
import Grade from '@comp/Grade';
import FixedFooter from '@comp/FixedFooter';
import CheckBoxGroup from './components/CheckBoxGroup';
import Rater from '@comp/Rate';
import {locationTo, storage} from '@utils/tools';
import {saveComment, editComment} from '@/store/api/doctor';

import './index.less';
import {COMMENT_KEY} from '@views/Comment/index';

export default observer(function (props) {
  let {comment_id} = queryString.parse(props.location.search);
  const dealStore = useStore('dealStore');
  let {
    deal_id,
    orig_doctor_id,
    doctor_id,
    user_id,
    doctor_name,
    user_name,
    city_id,
    city_name,
    clinic_name,
    clinic_id,
    patient_id,
    patient_name,
    patient_sex,
    patient_age,
    patient_phone,
  } = dealStore.deal || storage.get('deal') || {};

  const swRef = useRef(null);
  const [form, setForm] = useState(storage.get('comment') || {});
  const [slideIndex, setSlideIndex] = useState(0);
  const [map, setMap] = useState({});
  const [list, setList] = useState([]);
  const [niceList, setNiceList] = useState([]);
  const [isEnd, setIsEnd] = useState(true);
  const [isMP, setMP] = useState(storage.get(COMMENT_KEY, 'session') === 'mp');
  const settings = {
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };
  const quesList = {
    '1_1': {
      tag: '①.挂号服务',
      tit: `请问您对挂号服务不满意的地方有哪些？`,
      multiple: true,
      ans: [
        {val: '服务态度不好'},
        {val: '挂号缴费排队时间长', placeholder: '您能够接受的排队时间', remark: true},
        {val: '其它（请注明）', remark: true},
      ],
    },
    '2_1': {
      tag: '②.等候看诊时间',
      tit: `请问您今天等待问诊超过可接受时间多久？`,
      ans: [{val: '超过预期10-20分钟'}, {val: '超过预期30-40分钟'}, {val: '超过预期1个小时以上'}],
    },
    // '2-3': {
    //   tag: '③.医生看病服务',
    //   tit: `请问您对护士服务不满意的地方有哪些？`,
    //   ans: [
    //     {val: '服务态度不好'},
    //     {val: '不专业'},
    //     {val: '反馈慢'},
    //     {val: '没什么不满意'},
    //     {val: '其它（请注明）', remark: true},
    //   ],
    // },
    '3_1': {
      tag: '③.护士服务',
      tit: `请问您对护士服务不满意的地方有哪些？`,
      multiple: true,
      ans: [{val: '服务态度不好'}, {val: '不专业'}, {val: '反馈慢'}, {val: '其它（请注明）', remark: true}],
    },
    '4_1': {
      tag: '④.药房服务',
      tit: `请问您对药房服务不满意的地方有哪些？`,
      multiple: true,
      ans: [
        {val: '药房人员态度不好'},
        {val: '药品配送不及时'},
        {val: '排队等药时间长', placeholder: '您能够接受的排队时间', remark: true},
        {val: '其它（请注明）', remark: true},
      ],
    },
    '5_1': {
      tag: '⑤.环境与设施',
      tit: `请问您对分院内环境与设施不满意的地方有哪些？`,
      multiple: true,
      ans: [
        {val: '标识指引不清晰'},
        {val: '清洁卫生不好'},
        {val: '休息椅子不够'},
        {val: '秩序乱'},
        {val: '其它（请注明）', remark: true},
      ],
    },
  };

  useEffect(() => {
    setForm(storage.get('comment') || {});
  }, []);

  useEffect(() => {
    if (form.question_paper && form.question_paper.length) init();
  }, [slideIndex]);

  const init = () => {
    form.question_paper.forEach((item, idx) => {
      if (item) {
        onEvaluate(Number(item.score), idx + 1, item.tag, item.note);
      }
    });
  };

  const setDefScore = idx => {
    if (!form.question_paper || !form.question_paper.length || !form.question_paper[idx]) return 0;
    return Number(form.question_paper[idx].score || 0);
  };

  const onGetScore = (score, key) => {
    form[key] = `${score}`;
    setForm({...form});
  };

  const onEvaluate = (score, idx, tag, note) => {
    let list = [],
      tmpList = [];
    map[idx + '_1'] = {no: idx + '_1', question: '', score: `${score}`, tag: tag || [], note: note || []};

    let arr = [...(form.question_paper || [])].map(item => (item ? item : null));
    arr[idx - 1] = {no: idx + '_1', question: '', score: `${score}`, tag: tag || [], note: note || []};
    form.question_paper = arr;

    form.question_paper.forEach((item, idx) => {
      if (item && Number(item.score) <= 4) {
        list.push({...quesList[item.no], key: item.no});
        tmpList.push(idx);
      }
    });
    list = onSort(list, 'key');
    tmpList.sort();

    setIsEnd(slideIndex === 1 ? true : !list.length);
    setForm({...form});
    setMap({...map});
    setNiceList([...tmpList]);
    setList([...list]);
  };

  const onSort = (list, key) => {
    const arr = list.sort((a, b) => {
      if (a[key].split('_')[0] > b[key].split('_')[0]) {
        return 1;
      } else {
        return -1;
      }
    });

    return arr;
  };

  const onPrev = () => {
    storage.set('comment', form);
    if (!slideIndex) {
      props.history.goBack();
    } else {
      swRef.current.slickPrev();
      setSlideIndex(slideIndex - 1);
      setIsEnd(false);
    }
  };
  const onNext = () => {
    const {question_paper, total_score} = form;
    switch (slideIndex) {
      case 0:
        const r = question_paper.filter(item => item);
        if (total_score && question_paper && r.length === 5) {
          setIsEnd(true);
          onSlideNext();
        } else {
          Toast.fail('请先评分');
        }
        break;
      case 1:
        if (question_paper && question_paper.length === 5) {
          onSlideNext();
        } else {
          Toast.fail('您还有分数没评');
        }
        break;
      default:
        if (question_paper[niceList[slideIndex - 2]].tag.length) {
          onSlideNext();
        } else {
          Toast.fail('您还没有答题');
        }
    }
  };

  const onSlideNext = () => {
    swRef.current.slickNext();
    setSlideIndex(slideIndex + 1);
    storage.set('comment', form);
  };

  const onChangeChk = (val, key) => {
    const idx = form.question_paper.findIndex(item => item && item.no === key);
    const tag = val.filter(item => !item.remark).map(item => item.val);
    const note = val.map(item => item.note).filter(item => !!item);
    form.question_paper[idx] = {
      ...form.question_paper[idx],
      tag: [...tag, ...note],
      note,
    };

    setForm({...form});
  };

  const onHandleDefList = idx => {
    const {question_paper} = form;
    if (!question_paper) return [];

    let a = [];
    niceList.forEach(item => {
      a.push(question_paper[item]);
    });

    if (question_paper && a[idx] && a[idx].tag) {
      return a[idx];
    } else {
      return {};
    }
  };

  const onSubmit = async () => {
    storage.set('comment', form);
    if (list.length) {
      const last = list[list.length - 1];
      const {key} = last;
      const idx = form.question_paper.findIndex(item => item.no === key);
      if (!form.question_paper[idx].tag.length) {
        Toast.fail('您还没有答题');
        return;
      }
    } else {
      const a = form.question_paper.filter(item => item);
      if (!form.total_score || !form.question_paper || a.length !== 5) {
        Toast.fail('请选择评分');
        return;
      }
    }

    const params = {
      ...form,
      deal_id,
      doctor_id: orig_doctor_id,
      mis_doctor_id: doctor_id,
      doctor_name,
      user_id,
      user_name,
      city_id,
      city_name,
      clinic_name,
      clinic_id,
      visit_user_id: patient_id,
      visit_user_name: patient_name,
      visit_user_sex: patient_sex,
      visit_user_age: patient_age,
      patient_phone,
      type: '1',
    };
    let res = {};
    console.log('params', params);
    if (comment_id) {
      params.comment_id = comment_id;
      res = await editComment(params);
    } else {
      res = await saveComment(params);
    }
    const {status, message, coupon_list} = res;
    if (status === '0') {
      dealStore.resetDeal();
      storage.remove('comment');
      Modal.alert('成功', `评价成功！`, [
        {
          text: '确定',
          onPress: () => {
            const goUser = () => {
              let wx = window.wx || {};
              if (isMP) {
                wx.miniProgram.switchTab({
                  url: `/pages/user/index`, //跳转到小程序个人页
                });
              } else {
                location.href = location.origin + '/usercenter';
              }
            };
            if (comment_id) {
              goUser();
            } else {
              storage.set('commentCoupons', coupon_list);
              if (coupon_list.length) {
                props.history.push('/comment/suc' + props.location.search);
              } else {
                goUser();
              }
            }
          },
        },
      ]);

      /*Toast.success('评价成功', 1.5, () => {
        if (comment_id) {
          location.href = location.origin + '/usercenter';
        } else {
          storage.set('commentCoupons', coupon_list);
          if (coupon_list.length) {
            props.history.push('/comment/suc' + props.location.search);
          } else {
            location.href = location.origin + '/usercenter';
          }
        }
      });*/
    } else {
      Toast.fail(message);
    }
  };

  return (
    <section className="ques-wrapper">
      {!isMP && <BackHeader title={'固生堂就医评价'} />}
      <div className="main">
        <Slider ref={swRef} {...settings}>
          <div className="slider-page">
            <div className="ques">
              <div className="ques-tit">1. 根据您今天的就诊经历，您对固生堂服务的总体满意程度是？</div>
              <Rater rate={Number(form.total_score || 0)} onRate={val => onGetScore(val, 'total_score')} />
            </div>
            <div className="ques">
              <div className="ques-tit">2.根据这次经历，您对固生堂以下各项服务的满意程度是？</div>
              {Object.values(quesList).map((item, idx) => (
                <div className="ques-sub" key={idx}>
                  <div className="ques-sub-tit">{item.tag}</div>
                  <Rater rate={setDefScore(idx)} onRate={val => onEvaluate(val, idx + 1)} />
                </div>
              ))}
            </div>
          </div>
          {list.length ? (
            <div className="slider-page">
              {list.map((item, idx) => (
                <div className="ques" key={idx}>
                  <div className="ques-tit">
                    {`${idx + 3}. `}
                    {item.tit}
                    {item.multiple ? '（多选）' : ''}
                  </div>
                  <CheckBoxGroup
                    list={item.ans}
                    defList={onHandleDefList(idx)}
                    multiple={item.multiple}
                    onChange={val => onChangeChk(val, item.key)}
                  />
                </div>
              ))}
            </div>
          ) : null}
        </Slider>
      </div>
      <FixedFooter>
        <div className="btn btn-prev" onClick={onPrev}>
          {slideIndex === 0 ? '上一页' : '上一题'}
        </div>
        {isEnd ? (
          <div className="btn btn-next" onClick={onSubmit}>
            提交
          </div>
        ) : (
          <div className="btn btn-next" onClick={onNext}>
            下一题
          </div>
        )}
      </FixedFooter>
    </section>
  );
});
